// @flow
import React, { Fragment } from "react";
import classNames from "classnames";
import _ from "underscore";

// rounds a number to 1dp and removes trailing zeros after decimal point
function percent(number) {
  if (number && number > 0) return parseFloat(number.toFixed(1));
  else return "";
}

const colSpan = 4;

export default function FailureTds({ pass, amber, fail, total, title, round = false }) {
  return (
    <Fragment>
      <td className={classNames("pass", "left_data")}>
        {pass > 0 && (round ? percent(pass) : pass)}
      </td>
      <td className={classNames("amber")}>{amber > 0 && (round ? percent(amber) : amber)}</td>
      <td className={classNames("fail")}>{fail > 0 && (round ? percent(fail) : fail)}</td>
      <td className={classNames("total", "right_data")}>
        {total > 0 && (round ? "" : total)}
      </td>
    </Fragment>
  );
}

export { colSpan };
